import { IframeResizer } from '@open-iframe-resizer/react'
import cn from 'clsx'

type Props = {
  aspect?: string
  src: string
  title: string
}

export default function Iframe({ aspect, src, title }: Props) {
  /* Shorter than square on phones but still taller than the desktop ratio, for
     visuals that need vertical room to stay legible when the frame is narrow. */
  if (aspect === '10/7 sm:10/5') {
    return (
      <iframe
        className='aspect-10/7 w-full overflow-hidden min-[801px]:aspect-10/5 [&::-webkit-scrollbar]:hidden'
        src={src}
        title={title}
        scrolling='no'
        style={{
          overflow: 'hidden',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none'
        }}
      />
    )
  }

  if (aspect === 'sm:10/5') {
    return (
      <iframe
        className='aspect-square w-full overflow-hidden min-[801px]:aspect-10/5 [&::-webkit-scrollbar]:hidden'
        src={src}
        title={title}
        scrolling='no'
        style={{
          overflow: 'hidden',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none'
        }}
      />
    )
  }

  if (aspect) {
    const className = cn('w-full overflow-hidden [&::-webkit-scrollbar]:hidden', {
      'aspect-square sm:aspect-10/4': aspect === 'sm:10/4',
      'aspect-1/2 sm:aspect-8/10': aspect === 'sm:1/2',
      /* 1-0 wide */
      'aspect-10/1': aspect === '10/1',
      'aspect-10/2': aspect === '10/2',
      'aspect-10/3': aspect === '10/3',
      'aspect-10/4': aspect === '10/4',
      'aspect-10/5': aspect === '10/5',
      'aspect-10/6': aspect === '10/6',
      'aspect-10/7': aspect === '10/7',
      'aspect-10/8': aspect === '10/8',
      'aspect-10/9': aspect === '10/9',
      /* 10 square */
      'aspect-10/10': aspect === '10/10',
      /* 10-20 tall */
      'aspect-10/11': aspect === '10/11',
      'aspect-10/12': aspect === '10/12',
      'aspect-10/13': aspect === '10/13',
      'aspect-10/14': aspect === '10/14',
      'aspect-10/15': aspect === '10/15',
      'aspect-10/16': aspect === '10/16',
      'aspect-10/17': aspect === '10/17',
      'aspect-10/18': aspect === '10/18',
      'aspect-10/19': aspect === '10/19',
      /* Miscellaneous */
      'aspect-8/5': aspect === '8/5',
      'aspect-8/10': aspect === '8/10',
      'aspect-3/1': aspect === '3/1',
      'aspect-5/2': aspect === '5/2',
      'aspect-2/1': aspect === '2/1',
      'aspect-24/11': aspect === '24/11',
      'aspect-4/3': aspect === '4/3',
      'aspect-4/1': aspect === '4/1'
    })

    return (
      <iframe
        className={className}
        src={src}
        title={title}
        scrolling='no'
        style={{
          overflow: 'hidden',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none'
        }}
      />
    )
  }

  return (
    <IframeResizer
      className='h-0 w-full overflow-hidden [&::-webkit-scrollbar]:hidden'
      src={src}
      title={title}
      scrolling='no'
      style={{
        overflow: 'hidden',
        msOverflowStyle: 'none',
        scrollbarWidth: 'none'
      }}
    />
  )
}

Iframe.scheme = {
  render: 'Iframe',
  attributes: {
    aspect: { type: String },
    src: { type: String, required: true },
    title: { type: String, required: true }
  }
}
